export enum WatermarkPositions {
  Center = "Center",
  Top_Left = "Top Left",
  Top = "Top",
  Top_Right = "Top Right",
  Right = "Right",
  Bottom_Right = " Bottom Right",
  Bottom = "Bottom",
  Bottom_Left = "Bottom Left",
  Left = "Left",
}

export default WatermarkPositions;
